import {Howl} from 'howler';

export default class Sound {

    private _volume: number = 1;

    private instanceId: number = null;
    private howl: Howl | null;

    constructor(howl: Howl | null) {
        this.howl = howl;
    }

    public play(): void {
        if (!this.howl) return;
        if (this.instanceId !== null) {
            this.instanceId = this.howl.play(this.instanceId);
        } else {
            this.instanceId = this.howl.play();
        }
    }

    public stop(): void {
        if (!this.howl) return;
        this.howl.stop(this.instanceId);
    }

    public pause(): void {
        if (!this.howl) return;
        this.howl.pause(this.instanceId);
    }

    public seek(value: number) {
        if (!this.howl) return;
        this.howl.seek(value, this.instanceId);
    }

    get volume(): number {
        return this._volume;
    }

    set volume(value: number) {
        this._volume = value;
        if (!this.howl) return;
        this.howl.volume(this._volume * this.howl.volume(), this.instanceId);
    }

    set mute(value: boolean) {
        if (!this.howl) return;
        this.howl.mute(value, this.instanceId);
    }

    get duration(): number {
        if (!this.howl) return 0;
        return this.howl.duration(this.instanceId);
    }

    set loop(value: boolean) {
        if (!this.howl) return;
        this.howl.loop(value, this.instanceId);
    }
    /* eslint-disable */
    public on(event: string, callback: any): void {
        if (!this.howl) return;
        this.howl.on(event, callback, this.instanceId);
    }
    /* eslint-disable */
    public off(event: string, callback: any): void {
        if (!this.howl) return;
        this.howl.off(event, callback, this.instanceId);
    }
}
